var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroomsRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4052 28.978C21.3572 29.583 20.9924 30.9444 21.5975 31.9923C22.2025 33.0403 23.5639 33.405 24.6118 32.8C25.6598 32.195 26.0245 30.8336 25.4195 29.7857C24.8145 28.7377 23.4531 28.3729 22.4052 28.978ZM24.1848 32.0603C23.5374 32.4341 22.7109 32.2127 22.3371 31.5653C21.9633 30.9179 22.1848 30.0914 22.8322 29.7176C23.4796 29.3439 24.3061 29.5653 24.6798 30.2127C25.0536 30.8601 24.8321 31.6866 24.1848 32.0603Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 7.8113C10.9483 8.06673 10.861 8.3932 10.6055 8.54067C10.3501 8.68815 10.0237 8.60051 9.87627 8.34508C9.72892 8.08987 9.81621 7.7634 10.0716 7.61592C10.3271 7.46845 10.6535 7.55608 10.8008 7.8113Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5821 10.8942C12.7295 11.1496 12.6422 11.4761 12.3868 11.6236C12.1314 11.771 11.805 11.6834 11.6575 11.428C11.5102 11.1728 11.5975 10.8463 11.8529 10.6988C12.1083 10.5513 12.4347 10.639 12.5821 10.8942Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3613 13.9769C14.5088 14.2324 14.4215 14.5588 14.1661 14.7063C13.9107 14.8538 13.5843 14.7662 13.4368 14.5107C13.2895 14.2555 13.3768 13.929 13.6322 13.7816C13.8876 13.6341 14.214 13.7217 14.3613 13.9769Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1406 17.0585C16.2881 17.3139 16.2008 17.6404 15.9454 17.7879C15.69 17.9353 15.3636 17.8477 15.2161 17.5923C15.0688 17.3371 15.1561 17.0106 15.4115 16.8631C15.6669 16.7156 15.9933 16.8033 16.1406 17.0585Z",
    fill: "#FF0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9199 20.1414C18.0674 20.3968 17.9801 20.7233 17.7247 20.8708C17.4693 21.0182 17.1429 20.9306 16.9954 20.6752C16.8481 20.4199 16.9354 20.0935 17.1908 19.946C17.4462 19.7985 17.7726 19.8862 17.9199 20.1414Z",
    fill: "#FF0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1504 10.2431C10.2979 10.4985 10.2106 10.825 9.95516 10.9724C9.69973 11.1199 9.37335 11.0323 9.22587 10.7768C9.07853 10.5216 9.16582 10.1952 9.42125 10.0477C9.67668 9.90021 10.0031 9.98785 10.1504 10.2431Z",
    fill: "#FF0000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9297 13.3259C12.0772 13.5814 11.9899 13.9078 11.7345 14.0553C11.479 14.2028 11.1526 14.1152 11.0052 13.8597C10.8578 13.6045 10.9451 13.278 11.2005 13.1306C11.456 12.9831 11.7824 13.0707 11.9297 13.3259Z",
    fill: "#FF0000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.709 16.4075C13.8565 16.6629 13.7692 16.9894 13.5137 17.1369C13.2583 17.2843 12.9319 17.1967 12.7845 16.9413C12.6371 16.6861 12.7244 16.3596 12.9798 16.2121C13.2353 16.0646 13.5617 16.1523 13.709 16.4075Z",
    fill: "#FF0000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4883 19.4903C15.6358 19.7457 15.5485 20.0722 15.293 20.2196C15.0376 20.3671 14.7112 20.2795 14.5638 20.024C14.4164 19.7688 14.5037 19.4424 14.7591 19.2949C15.0146 19.1474 15.341 19.235 15.4883 19.4903Z",
    fill: "#FF0000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2324 8.46364C13.3799 8.71907 13.2926 9.04554 13.0372 9.19302C12.7818 9.34049 12.4554 9.25285 12.3079 8.99742C12.1606 8.74221 12.2479 8.41574 12.5033 8.26827C12.7587 8.12079 13.0851 8.20843 13.2324 8.46364Z",
    fill: "#FF0000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0117 11.5452C15.1592 11.8006 15.0719 12.1271 14.8165 12.2746C14.5611 12.422 14.2347 12.3344 14.0872 12.079C13.9399 11.8238 14.0271 11.4973 14.2826 11.3498C14.538 11.2023 14.8644 11.29 15.0117 11.5452Z",
    fill: "#FF0000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.791 14.6281C16.9385 14.8835 16.8512 15.21 16.5958 15.3574C16.3404 15.5049 16.014 15.4173 15.8665 15.1619C15.7192 14.9066 15.8064 14.5802 16.0619 14.4327C16.3173 14.2852 16.6437 14.3729 16.791 14.6281Z",
    fill: "#FF0000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5723 17.7108C18.7198 17.9663 18.6325 18.2927 18.377 18.4402C18.1216 18.5877 17.7952 18.5 17.6478 18.2446C17.5004 17.9894 17.5877 17.6629 17.8431 17.5155C18.0986 17.368 18.4249 17.4556 18.5723 17.7108Z",
    fill: "#FF0000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8848 6.03188C14.0323 6.28731 13.945 6.61378 13.6895 6.76125C13.4341 6.90873 13.1077 6.82109 12.9602 6.56566C12.8129 6.31045 12.9002 5.98398 13.1556 5.8365C13.4111 5.68903 13.7374 5.77667 13.8848 6.03188Z",
    fill: "#FF0000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6641 9.11477C15.8116 9.3702 15.7243 9.69667 15.4688 9.84414C15.2134 9.99161 14.887 9.90398 14.7395 9.64855C14.5922 9.39333 14.6795 9.06686 14.9349 8.91939C15.1904 8.77192 15.5167 8.85955 15.6641 9.11477Z",
    fill: "#FF0000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4434 12.1975C17.5909 12.453 17.5036 12.7794 17.2481 12.9269C16.9927 13.0744 16.6663 12.9867 16.5188 12.7313C16.3715 12.4761 16.4588 12.1496 16.7142 12.0022C16.9696 11.8547 17.296 11.9423 17.4434 12.1975Z",
    fill: "#FF0000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2227 15.2791C19.3701 15.5345 19.2829 15.861 19.0274 16.0084C18.772 16.1559 18.4456 16.0683 18.2981 15.8129C18.1508 15.5576 18.2381 15.2312 18.4935 15.0837C18.7489 14.9362 19.0753 15.0239 19.2227 15.2791Z",
    fill: "#FF0000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.002 18.362C21.1494 18.6174 21.0621 18.9439 20.8067 19.0913C20.5513 19.2388 20.2249 19.1512 20.0774 18.8957C19.9301 18.6405 20.0174 18.3141 20.2728 18.1666C20.5282 18.0191 20.8546 18.1067 21.002 18.362Z",
    fill: "#FF0000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0938 9.76577C18.2412 10.0212 18.1539 10.3477 17.8985 10.4951C17.6431 10.6426 17.3167 10.555 17.1692 10.2995C17.0219 10.0443 17.1092 9.71786 17.3646 9.57039C17.62 9.42292 17.9464 9.51055 18.0938 9.76577Z",
    fill: "#FF0000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 12.8487C20.0225 13.1041 19.9352 13.4306 19.6798 13.578C19.4243 13.7255 19.098 13.6379 18.9505 13.3824C18.8031 13.1272 18.8904 12.8007 19.1459 12.6533C19.4013 12.5058 19.7277 12.5934 19.875 12.8487Z",
    fill: "#FF0000"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71877 9.59206C7.86624 9.84749 7.77894 10.174 7.52352 10.3214C7.26809 10.4689 6.94171 10.3813 6.79423 10.1258C6.64689 9.87063 6.73418 9.54416 6.98961 9.39668C7.24504 9.24921 7.57142 9.33685 7.71877 9.59206Z",
    fill: "#FF0000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49807 12.6736C9.64554 12.929 9.55824 13.2555 9.30281 13.403C9.04738 13.5504 8.721 13.4628 8.57353 13.2074C8.42618 12.9522 8.51348 12.6257 8.76891 12.4782C9.02434 12.3308 9.35072 12.4184 9.49807 12.6736Z",
    fill: "#FF0000"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2793 15.7564C11.4268 16.0118 11.3395 16.3383 11.0841 16.4857C10.8286 16.6332 10.5023 16.5456 10.3548 16.2901C10.2074 16.0349 10.2947 15.7085 10.5502 15.561C10.8056 15.4135 11.132 15.5012 11.2793 15.7564Z",
    fill: "#FF0000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0586 18.8393C13.2061 19.0947 13.1188 19.4212 12.8634 19.5686C12.6079 19.7161 12.2816 19.6285 12.1341 19.373C11.9867 19.1178 12.074 18.7913 12.3295 18.6439C12.5849 18.4964 12.9113 18.584 13.0586 18.8393Z",
    fill: "#FF0000"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8379 21.9207C14.9854 22.1761 14.8981 22.5026 14.6427 22.65C14.3872 22.7975 14.0608 22.7099 13.9134 22.4545C13.766 22.1992 13.8533 21.8728 14.1088 21.7253C14.3642 21.5778 14.6906 21.6655 14.8379 21.9207Z",
    fill: "#FF0000"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84767 15.1054C8.99515 15.3608 8.90785 15.6873 8.65242 15.8347C8.39699 15.9822 8.07061 15.8946 7.92314 15.6391C7.77579 15.3839 7.86309 15.0575 8.11852 14.91C8.37395 14.7625 8.70033 14.8502 8.84767 15.1054Z",
    fill: "#FF0000"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.627 18.1868C10.7744 18.4422 10.6871 18.7687 10.4317 18.9162C10.1763 19.0636 9.84991 18.976 9.70244 18.7206C9.55509 18.4654 9.64238 18.1389 9.89781 17.9914C10.1532 17.8439 10.4796 17.9316 10.627 18.1868Z",
    fill: "#FF0000"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5598 20.1343C23.6902 17.1803 23.3332 13.3588 21.3578 9.93729C18.2967 4.63539 12.4764 2.24227 8.34606 4.62694C4.21568 7.01162 3.37811 13.2488 6.4391 18.5506C8.41446 21.972 11.5455 24.192 14.669 24.6901C14.669 24.6901 14.6867 24.7209 14.7175 24.7031C14.766 24.7161 17.9784 25.3684 18.8757 31.5495C18.8852 31.7083 18.9589 32.4056 19.4572 33.2687C20.7563 35.5187 23.6249 36.2876 25.8752 34.9883C28.1253 33.6893 28.8762 30.7897 27.5772 28.5396C27.0789 27.6766 26.5119 27.264 26.379 27.1765C21.5721 23.3353 22.5208 20.2802 22.5598 20.1343ZM7.17887 18.1235C4.34932 13.2226 5.07426 7.50227 8.77317 5.36671C12.4721 3.23115 17.7884 5.46332 20.618 10.3644C23.4476 15.2653 22.7226 20.9856 19.0237 23.1212C15.3248 25.2567 10.0084 23.0244 7.17887 18.1235ZM25.8789 27.8762C25.9274 27.8892 26.3924 28.1961 26.8373 28.9667C27.8872 30.7852 27.2797 33.1498 25.4303 34.2176C23.5808 35.2854 21.2294 34.6293 20.1794 32.8108C19.7523 32.0709 19.7012 31.484 19.7012 31.484C19.7012 31.484 19.6835 31.4533 19.7142 31.4355C19.1675 27.6414 17.7772 25.7315 16.603 24.7656C17.6178 24.6727 18.5569 24.3771 19.4509 23.8609C20.3447 23.3449 21.0523 22.6485 21.6583 21.8469C21.9075 23.3466 22.8664 25.5054 25.879 27.8763L25.8789 27.8762Z",
    fill: "#FF0000"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7942 10.2612C23.7625 15.4024 22.8087 21.1689 19.1246 23.2959C15.4404 25.4229 9.96967 23.3657 7.00139 18.2245C4.03311 13.0833 4.9869 7.31691 8.67104 5.18987C12.3552 3.06283 17.8259 5.12003 20.7942 10.2612Z",
    stroke: "black",
    strokeWidth: 1.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.856 30.1098C25.2859 30.8545 25.0307 31.8068 24.2858 32.2369C23.5409 32.667 22.5885 32.4118 22.1586 31.6672C21.7287 30.9225 21.9839 29.9701 22.7288 29.5401C23.4737 29.11 24.4261 29.3652 24.856 30.1098Z",
    stroke: "black",
    strokeWidth: 1.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0466 28.8457C28.1744 30.7992 27.5049 33.2973 25.551 34.4254C23.5971 35.5535 21.0989 34.8842 19.9711 32.9307C18.8433 30.9773 19.5128 28.4791 21.4667 27.3511C23.4206 26.223 25.9187 26.8923 27.0466 28.8457Z",
    stroke: "black",
    strokeWidth: 1.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.247 19.0055C21.8332 20.899 22.0966 22.9466 23.142 24.7572C23.7971 25.8917 24.6862 26.8069 25.7132 27.4769",
    stroke: "black",
    strokeWidth: 1.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8487 23.8544C15.6954 24.4428 17.3369 25.6947 18.3822 27.5053C19.0373 28.6399 19.3853 29.8675 19.4521 31.0919",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.34501,
    cy: 9.88233,
    r: 0.6,
    transform: "rotate(-30 7.34501 9.88233)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.12626,
    cy: 12.9675,
    r: 0.6,
    transform: "rotate(-30 9.12626 12.9675)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9036,
    cy: 16.046,
    r: 0.6,
    transform: "rotate(-30 10.9036 16.046)",
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6848,
    cy: 19.1312,
    r: 0.6,
    transform: "rotate(-30 12.6848 19.1312)",
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4641,
    cy: 22.213,
    r: 0.6,
    transform: "rotate(-30 14.4641 22.213)",
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.429,
    cy: 8.10267,
    r: 0.6,
    transform: "rotate(-30 10.429 8.10267)",
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2102,
    cy: 11.1879,
    r: 0.6,
    transform: "rotate(-30 12.2102 11.1879)",
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9876,
    cy: 14.2664,
    r: 0.6,
    transform: "rotate(-30 13.9876 14.2664)",
    fill: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7688,
    cy: 17.3516,
    r: 0.6,
    transform: "rotate(-30 15.7688 17.3516)",
    fill: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5481,
    cy: 20.4334,
    r: 0.6,
    transform: "rotate(-30 17.5481 20.4334)",
    fill: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.511,
    cy: 6.32313,
    r: 0.6,
    transform: "rotate(-30 13.511 6.32313)",
    fill: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2923,
    cy: 9.40834,
    r: 0.6,
    transform: "rotate(-30 15.2923 9.40834)",
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0696,
    cy: 12.4868,
    r: 0.6,
    transform: "rotate(-30 17.0696 12.4868)",
    fill: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8509,
    cy: 15.572,
    r: 0.6,
    transform: "rotate(-30 18.8509 15.572)",
    fill: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6302,
    cy: 18.6538,
    r: 0.6,
    transform: "rotate(-30 20.6302 18.6538)",
    fill: "black"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8606,
    cy: 8.75477,
    r: 0.6,
    transform: "rotate(-30 12.8606 8.75477)",
    fill: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6419,
    cy: 11.84,
    r: 0.6,
    transform: "rotate(-30 14.6419 11.84)",
    fill: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4192,
    cy: 14.9185,
    r: 0.6,
    transform: "rotate(-30 16.4192 14.9185)",
    fill: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2005,
    cy: 18.0037,
    r: 0.6,
    transform: "rotate(-30 18.2005 18.0037)",
    fill: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7239,
    cy: 10.0604,
    r: 0.6,
    transform: "rotate(-30 17.7239 10.0604)",
    fill: "black"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5013,
    cy: 13.1389,
    r: 0.6,
    transform: "rotate(-30 19.5013 13.1389)",
    fill: "black"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.77665,
    cy: 10.5352,
    r: 0.6,
    transform: "rotate(-30 9.77665 10.5352)",
    fill: "black"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5579,
    cy: 13.6204,
    r: 0.6,
    transform: "rotate(-30 11.5579 13.6204)",
    fill: "black"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3352,
    cy: 16.6989,
    r: 0.6,
    transform: "rotate(-30 13.3352 16.6989)",
    fill: "black"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1165,
    cy: 19.7841,
    r: 0.6,
    transform: "rotate(-30 15.1165 19.7841)",
    fill: "black"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.47782,
    cy: 15.3993,
    r: 0.6,
    transform: "rotate(-30 8.47782 15.3993)",
    fill: "black"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2552,
    cy: 18.4778,
    r: 0.6,
    transform: "rotate(-30 10.2552 18.4778)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroomsRoom);
export default __webpack_public_path__ + "static/media/GroomsRoom.54efdda326a6103dd38ef8cc9472512a.svg";
export { ForwardRef as ReactComponent };